'use strict';

const react = require('@emotion/react');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_navigation_PageNavigation_PageNavigationRow = require('./PageNavigationRow.cjs.js');
const components_navigation_PageNavigation_utils_checkIsTruncated = require('./utils/checkIsTruncated.cjs.js');

const Styles = {
  textEllipsis: (textColor) => react.css`
    color: ${theme_Colors.Colors[textColor]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  // The width value for textWrap is 90% of the row width, less the 33px
  // difference in text indentation between the first and second nested
  // rows.
  textWrap: react.css`
    align-items: center;
    border-left: 1px solid ${theme_Colors.Colors.GrayWarm4};
    display: flex;
    flex-direction: row;
    padding: var(--zds-space-8) 0px;
    width: calc(90% - 33px);
  `,
  rowContainer: react.css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px var(--zds-space-24) 0px 60px;
    position: relative;
  `
};
function NestedThirdRow({ item, onSelect }) {
  const [isTruncated, setIsTruncated] = React.useState(false);
  const textRef = React.useRef(null);
  React.useEffect(() => {
    setIsTruncated(components_navigation_PageNavigation_utils_checkIsTruncated(textRef));
  }, []);
  const InnerContent = ({ hover, selected }) => {
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    const textType = selected ? "Body3" : "Body2";
    return react.jsx(
      "div",
      { css: Styles.rowContainer, "data-zds": true },
      react.jsx(
        "span",
        { css: Styles.textWrap, "data-zds": true },
        react.jsx(
          "span",
          { css: Styles.textEllipsis(textColor), ref: textRef, "data-zds": true },
          react.jsx(
            components_display_Text_Text.Text,
            { color: textColor, margin: "0 0 0 8px", type: textType },
            item.title,
            item.count && ` (${item.count})`
          )
        )
      )
    );
  };
  const Content = ({ hover, selected }) => isTruncated ? react.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: item.count ? `${item.title} (${item.count})` : item.title, isBlock: true, position: "northeast" }, () => react.jsx(InnerContent, { hover, selected })) : react.jsx(InnerContent, { hover, selected });
  return react.jsx(components_navigation_PageNavigation_PageNavigationRow, { content: Content, item, onSelect });
}

module.exports = NestedThirdRow;
//# sourceMappingURL=NestedThirdRow.cjs.js.map
